import { Flex, SkeletonText, Space, Spacing, Text } from '@billy/design-system'
import { t } from 'i18next'
import { ReactElement, useCallback } from 'react'

import { useBankLines, useBankLinesFilters } from '../../../../../paymentReconciliationModal/contexts'
import { BankLinesSearchInput } from './elements/BankLinesSearchInput'
import { BankLinesSortingPropertySelect } from './elements/BankLinesSortingPropertySelect'
import * as Styled from './styles'
import { BankLinesSortingProperty } from './types/bankLinesSortingProperty'

export const BankLinesActions = (): ReactElement => {
  const { bankLines, isLoading } = useBankLines()
  const { bankLinesSortingProperty, setBankLinesSortingProperty } = useBankLinesFilters()

  const bankLinesCount = bankLines?.length || 0

  const handleSortingPropertySelect = useCallback(
    (value?: BankLinesSortingProperty) => {
      if (value) {
        setBankLinesSortingProperty(value)
      }
    },
    [setBankLinesSortingProperty],
  )

  return (
    <>
      <Flex justifyContent="space-between" alignItems="center">
        {isLoading ? (
          <SkeletonText />
        ) : (
          <Text colorVariant="secondary">{t('bank_lines', { count: bankLinesCount })}</Text>
        )}
        <Flex gap={Spacing.S16}>
          <BankLinesSearchInput />
          <Styled.SortingPropertySelectWrapper>
            <BankLinesSortingPropertySelect
              dropdownSize="fitTrigger"
              onSelect={(id, value) => handleSortingPropertySelect(value)}
              selectedId={bankLinesSortingProperty}
              withSearch={false}
            />
          </Styled.SortingPropertySelectWrapper>
        </Flex>
      </Flex>
      <Space size="s8" />
    </>
  )
}
